import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'

import type { SignupModalSegment } from './segment'

type QueryValue = string | string[] | undefined

export interface SignupModalEligibilityQuery {
  usage?: QueryValue
  signupModalEntityType?: QueryValue
}

const ELIGIBLE_ENTITY_TYPES = ['PF', 'CNPJ']
const ELIGIBLE_SEGMENTS: SignupModalSegment[] = ['person', 'lawsuit']

export function isSignupModalExperimentEligible(
  query: SignupModalEligibilityQuery,
  segment: SignupModalSegment
): boolean {
  return (
    getFirstQueryParam(query.usage) === 'iframe' &&
    ELIGIBLE_ENTITY_TYPES.includes(getFirstQueryParam(query.signupModalEntityType)) &&
    ELIGIBLE_SEGMENTS.includes(segment)
  )
}
